import { ThemeProvider } from '@mui/material';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Slide from '@mui/material/Slide';
import { customDialogTheme } from 'assets/styles/themes/Dialog/generic_dialog_mui';
import { ImportContext } from 'providers/ImportStatus';
import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import { updateExploitation } from 'services/API/Secteur';
import { ExploitationContext } from 'utils/context';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const ChangeCodeExploitationModal = ({ navigateAfterImport }) => {
  const {
    result,
    warningDataFromImport,
    isOpenChangeCodeModal,
    setIsOpenChangeCodeModal,
    importOriginLocation,
    setMessageToDisplayInResult,
  } = useContext(ImportContext);
  const { t } = useTranslation();
  const { exploitationContext, setExploitationContext } = useContext(ExploitationContext);

  const keepOrChangeCodeAfterImport = async ({ keepCode = true } = {}) => {
    setIsOpenChangeCodeModal(false);
    if (!keepCode) {
      try {
        await updateExploitation(
          { code: warningDataFromImport.oldCode },
          warningDataFromImport?.exploitationId
        );
        setMessageToDisplayInResult({
          exploitations: result.message.exploitations.map((exploitation, index) => {
            if (index === 0 && exploitation.message.length === 2) {
              return {
                ...exploitation,
                message: [
                  exploitation.message[0],
                  t('message.codeKeptAfterImport', { code: warningDataFromImport.oldCode }),
                ],
              };
            }
            return exploitation;
          }),
        });
      } catch (error) {
        toast.error(error.message);
      }
    }

    if (
      importOriginLocation === 'exploitation' &&
      exploitationContext?.id === warningDataFromImport?.exploitationId
    ) {
      setExploitationContext((prev) => ({
        ...prev,
        code: keepCode === false ? warningDataFromImport.oldCode : warningDataFromImport.newCode,
      }));
    }

    await navigateAfterImport();
  };

  return (
    <ThemeProvider theme={customDialogTheme}>
      <Dialog
        open={isOpenChangeCodeModal}
        slots={{
          transition: Transition,
        }}
        keepMounted
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle>{t('dialog.changeCodeAfterImportTitle')}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">
            {t('dialog.changeCodeAfterImportMessage', {
              oldCode: warningDataFromImport.oldCode,
              newCode: warningDataFromImport.newCode,
            })}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => keepOrChangeCodeAfterImport({ keepCode: true })}>
            {t('button.validateChange')}
          </Button>
          <Button onClick={() => keepOrChangeCodeAfterImport({ keepCode: false })}>
            {t('button.keepPreviousCode')}
          </Button>
        </DialogActions>
      </Dialog>
    </ThemeProvider>
  );
};

export default ChangeCodeExploitationModal;
